// src/com/app_main/AppHeader.js
import React, { useState, useEffect } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import HomeWorkIcon from '@mui/icons-material/HomeWork'; // Home
import InfoIcon from '@mui/icons-material/Info'; // 배차현황.
import UploadFileIcon from '@mui/icons-material/UploadFile'; // 운송요청 업로드.
import RedeemIcon from '@mui/icons-material/Redeem'; // 운송요청 조회
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'; // TSR
import StorefrontIcon from '@mui/icons-material/Storefront'; // 점포관리
import LocationOnIcon from '@mui/icons-material/LocationOn'; // 차량관제.
import NearMeIcon from '@mui/icons-material/NearMe'; // 차량위치 리스트.
import SummarizeIcon from '@mui/icons-material/Summarize'; // Report
import LocalShippingIcon from '@mui/icons-material/LocalShipping'; // 용차관리.
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard'; // 용차시간관리.
import DescriptionIcon from '@mui/icons-material/Description'; // Default.
import KeyIcon from '@mui/icons-material/Key'; // DC 전환
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { AppStyle, MenuUrl, MobileMenuId } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { currentMenuRepo, mobileMenuAuthListRepo, userInfoRepo } from '../../value/AppModel';

const MenuItemButton = styled(ListItemButton)({
    padding: '3px 10px 3px 10px',
});


export const MobileMenuMap = {
    [MobileMenuId.Home]: {url: MenuUrl.TopHome, icon: <HomeWorkIcon style={{color:'red'}} />},
    [MobileMenuId.TransPlanState]: {
        url: MenuUrl.TransPlanStateForDc,
        icon: <InfoIcon style={{color: AppStyle.PrimaryRGB}} />,
    }, //MenuUrl.TransPlanStateForDc, // Exception: TransPlanStateForCompany for 운송사
    [MobileMenuId.TransPlan]: {
        url: MenuUrl.TransPlanUpload,
        icon: <UploadFileIcon style={{color: AppStyle.SecondaryRGB}} />,
    },
    [MobileMenuId.TransPlanDownload]: {
        url: MenuUrl.TransPlanLaunch,
        icon: <RedeemIcon style={{color: AppStyle.InfoRGB}} />,
    }, // MenuUrl.TransPlanLaunch, // 운송요청 조회
    [MobileMenuId.TSR]: {
        url: MenuUrl.TSR,
        icon: <ReceiptLongIcon style={{color: AppStyle.SuccessRGB}} />,
    },
    [MobileMenuId.Store]: {
        url: MenuUrl.Store,
        icon: <StorefrontIcon style={{color: 'red'}} />,
    },
    [MobileMenuId.VehTransPos]: {
        url: MenuUrl.VehTransPos,
        icon: <LocationOnIcon style={{color: AppStyle.PrimaryRGB}} />,
    },
    [MobileMenuId.VehLocation]: {
        url: MenuUrl.VehLocation,
        icon: <NearMeIcon style={{color: AppStyle.SecondaryRGB}} />,
    },
    [MobileMenuId.Report]: {
        url: MenuUrl.Report,
        icon: <SummarizeIcon style={{color: AppStyle.InfoRGB}} />,
    },
    [MobileMenuId.ManageRentTime]: {
        url: MenuUrl.ManageRentTime,
        icon: <DepartureBoardIcon style={{color: AppStyle.WarnRGB}} />,
    },
    [MobileMenuId.ManageRent]: {
        url: MenuUrl.ManageRent,
        icon: <LocalShippingIcon style={{color: AppStyle.SuccessRGB}} />,
    }
};

export default function AppHeader({
    onSelectMenu,
    onRequestChangeDc,
}) {
    const sessionInfo = useReactiveVar(userInfoRepo);
    const menuListData = useReactiveVar(mobileMenuAuthListRepo);
    // const [currentMenu, setCurrentMenu] = useState({});
    const menuSelected = useReactiveVar(currentMenuRepo);
    const [openMenu, setOpenMenu] = useState(false);

    const onClickMenu = (menu) => {
        currentMenuRepo(menu);
        if(onSelectMenu) onSelectMenu(menu);
        setOpenMenu(false);
    };

    const onClickChangeDc = () => {
        onRequestChangeDc();
        setOpenMenu(false);
    };
    
    useEffect(() => {
        if(menuListData.records.length > 0 && !menuSelected.menuId) {
            const menu = menuListData.records[0];
            currentMenuRepo(menu);
            if(onSelectMenu) {
                onSelectMenu(menu);
            }
        }
    }, [menuListData, menuSelected, onSelectMenu]);

    return(
        <Box style={{
            display:'flex', alignItems:'center', padding: '0.5rem',
            backgroundColor: AppStyle.PrimaryRGB, color: 'white',
        }}>
            <IconButton onClick={()=>setOpenMenu(true)} style={{color:'white'}}>
                <MenuIcon/>
            </IconButton>
            <Box style={{flexGrow:1, display:'flex', alignItems:'center'}}>
                <div style={{fontWeight: 'bold', fontSize: '1.3rem', flexGrow:1, textAlign:'center'}}>
                    New TOP
                </div>
                <div style={{
                    fontSize: '0.85rem', marginLeft: '0.5rem',
                    color: '#ffc'
                }}>
                    {sessionInfo.user.dscNameAs}
                </div>
            </Box>
            <Drawer onClose={()=>setOpenMenu(false)} open={openMenu}>
                <List>
                    {
                        menuListData.records.map((menu) => {
                            return(
                                <MenuItemButton key={menu.menuId}
                                    selected={menuSelected.menuId === menu.menuId}
                                >
                                    <ListItemIcon>
                                        {
                                            MobileMenuMap.hasOwnProperty(menu.menuId) ?
                                            MobileMenuMap[menu.menuId].icon :
                                            <DescriptionIcon />
                                        }
                                    </ListItemIcon>
                                    <ListItem key={menu.menuId} style={{padding: 3}}
                                    >
                                        <ListItemText onClick={()=>onClickMenu(menu)}>
                                            {menu.menuName}
                                        </ListItemText>
                                    </ListItem>
                                </MenuItemButton>
                            );
                        })
                    }
                </List>
                <Divider />
                <List>
                    <MenuItemButton>
                        <ListItemIcon>
                            <AccountCircleIcon
                                style={{color: AppStyle.PrimaryRGB}}
                            />
                        </ListItemIcon>
                        <ListItem style={{padding: 3}}
                        >
                            <ListItemText>
                                {sessionInfo.user.userName}
                                <span style={{fontSize:'0.85rem', marginLeft: '0.5rem', color: '#777'}}>
                                    ({sessionInfo.user.dscNameAs})
                                </span>
                            </ListItemText>
                        </ListItem>
                    </MenuItemButton>
                    {
                        sessionInfo.user.allDcYn === 'Y' &&
                        <MenuItemButton>
                            <ListItemIcon>
                                <KeyIcon
                                    style={{color: AppStyle.SecondaryRGB}}
                                />
                            </ListItemIcon>
                            <ListItem style={{padding: 3}}
                            >
                                <ListItemText onClick={onClickChangeDc}>
                                    물류센터 전환
                                </ListItemText>
                            </ListItem>
                        </MenuItemButton>
                    }
                    <MenuItemButton>
                        <ListItemIcon>
                            <LogoutIcon
                                style={{color: AppStyle.WarnRGB}}
                            />
                        </ListItemIcon>
                        <ListItem style={{padding: 3}}
                        >
                            <ListItemText onClick={()=>onClickMenu({
                                menuId: MobileMenuId.LogOut,
                                menuName: '로그아웃',
                            })}>
                                로그아웃
                            </ListItemText>
                        </ListItem>
                    </MenuItemButton>
                </List>
            </Drawer>
        </Box>
    )
}